import React, { useState, useEffect } from 'react';
import Masonry from 'react-masonry-css';

import { IQuickStartGuideFields } from '../../../types/contentful';

import { breakpoints } from '../../styles/media-queries';

import { QuickStartGuideBox } from '../QuickStartGuideBox';
import { ImageWith5050Text } from '../ImageWith5050Text';
import { BlockContainer, Layout, BoxColumn } from '../Layout';

import { ToggleWrapper, Toggle } from './styles';
import {
  MasonryWrapper,
  MASONRY_CLASS,
  MASONRY_COL_CLASS
} from '../MasonryWrapper';

export function QuickStartGuide({
  beforeImageWith5050text,
  afterImageWith5050text,
  beforeBoxes,
  afterBoxes
}: IQuickStartGuideFields) {
  const [isMobile, setIsMobile] = useState(false);
  const [isAfter, setIsAfter] = useState(false);

  useEffect(() => {
    setIsMobile(
      typeof window !== `undefined` && window.innerWidth < breakpoints.tablet
    );
    setIsAfter(window.location.href.includes('after'));
  }, []);

  return (
    <>
      <BlockContainer
        marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
        marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
        data-blockid="quickStartGuideToggle"
      >
        <BoxColumn
          size={{ 0: 12, desktop: 10 }}
          paddingTop={{ 0: 0, desktop: 'xs' }}
        >
          <ToggleWrapper>
            <Toggle onClick={() => setIsAfter(false)} active={!isAfter}>
              <p>Set up your account</p>
            </Toggle>
            <Toggle onClick={() => setIsAfter(true)} active={isAfter}>
              <p>Set up your kids</p>
            </Toggle>
          </ToggleWrapper>
        </BoxColumn>
      </BlockContainer>
      {!isAfter ? (
        <>
          {beforeImageWith5050text && (
            <ImageWith5050Text {...beforeImageWith5050text?.fields} />
          )}
          <BlockContainer
            marginTop={{
              0: 0,
              tablet: 'blockMarginY_tablet'
            }}
            marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
            data-blockid="beforeBoxes"
          >
            <Layout>
              <BoxColumn
                size={{ 0: 12, desktop: 10 }}
                paddingTop={{ 0: 0, desktop: 'xs' }}
              >
                {isMobile &&
                  (beforeBoxes || []).map(({ sys, fields }) => (
                    <QuickStartGuideBox {...fields} key={sys?.id} />
                  ))}
                {!isMobile && (
                  <MasonryWrapper>
                    <Masonry
                      breakpointCols={2}
                      className={MASONRY_CLASS}
                      columnClassName={MASONRY_COL_CLASS}
                    >
                      {(beforeBoxes || []).map(({ sys, fields }) => (
                        <QuickStartGuideBox {...fields} key={sys?.id} />
                      ))}
                    </Masonry>
                  </MasonryWrapper>
                )}
              </BoxColumn>
            </Layout>
          </BlockContainer>
        </>
      ) : (
        <>
          {afterImageWith5050text && (
            <ImageWith5050Text {...afterImageWith5050text?.fields} />
          )}
          <BlockContainer
            marginTop={{
              0: 0,
              tablet: 'blockMarginY_tablet'
            }}
            marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
            data-blockid="afterBoxes"
          >
            <Layout>
              <BoxColumn
                size={{ 0: 12, desktop: 10 }}
                paddingTop={{ 0: 0, desktop: 'xs' }}
              >
                {isMobile &&
                  (afterBoxes || []).map(({ sys, fields }) => (
                    <QuickStartGuideBox {...fields} key={sys?.id} />
                  ))}
                {!isMobile && (
                  <MasonryWrapper>
                    <Masonry
                      breakpointCols={2}
                      className={MASONRY_CLASS}
                      columnClassName={MASONRY_COL_CLASS}
                    >
                      {(afterBoxes || []).map(({ sys, fields }) => (
                        <QuickStartGuideBox {...fields} key={sys?.id} />
                      ))}
                    </Masonry>
                  </MasonryWrapper>
                )}
              </BoxColumn>
            </Layout>
          </BlockContainer>
        </>
      )}
    </>
  );
}
